/**
 * /frontend/src/features/analytics/components/charts/HorizontalBarChart.js
 */

import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { CHART_CONFIG } from '../../constants/chartConfig';
import { CHART_COLORS } from '../../constants/chartColors';

/**
 * Horizontal bar chart.
 * @param {{data:any[],xKey:string,yKey:string,height?:number,color?:string,xFormatter?:(v:any)=>string}} props
 * @returns {JSX.Element}
 */
const HorizontalBarChart = ({ data, xKey, yKey, height, color, xFormatter }) => {
  const safeData = Array.isArray(data) ? data : [];
  if (!safeData.length) {
    return <div className="analytics-chart-empty-inline">No data available for the selected range.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={height || CHART_CONFIG.height}>
      <BarChart data={safeData} layout="vertical" margin={CHART_CONFIG.margin}>
        <CartesianGrid stroke={CHART_CONFIG.gridStroke} strokeDasharray="4 6" />
        <XAxis type="number" stroke={CHART_CONFIG.axisStroke} tick={{ fill: CHART_CONFIG.tickFill, fontSize: 12 }} tickFormatter={xFormatter} />
        <YAxis type="category" dataKey={xKey} stroke={CHART_CONFIG.axisStroke} tick={{ fill: CHART_CONFIG.tickFill, fontSize: 12 }} width={140} />
        <Tooltip formatter={xFormatter} />
        <Bar dataKey={yKey} fill={color || CHART_COLORS.accentAlt} radius={[0, 10, 10, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default HorizontalBarChart;
